var _TakeEnumerator_enumerator, _TakeEnumerator_itemsToTake, _TakeEnumerator_currentItem, _TakeEnumerator_itemsTaken;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import EnumeratorBase from "./EnumeratorBase";
import Exception from '../Exceptions/Exception';
export default class TakeEnumerator extends EnumeratorBase {
    constructor(enumerator, itemsToTake) {
        super();
        _TakeEnumerator_enumerator.set(this, void 0);
        _TakeEnumerator_itemsToTake.set(this, void 0);
        _TakeEnumerator_currentItem.set(this, void 0);
        _TakeEnumerator_itemsTaken.set(this, void 0);
        __classPrivateFieldSet(this, _TakeEnumerator_enumerator, enumerator, "f");
        __classPrivateFieldSet(this, _TakeEnumerator_itemsToTake, itemsToTake, "f");
        __classPrivateFieldSet(this, _TakeEnumerator_itemsTaken, 0, "f");
    }
    get current() {
        if (__classPrivateFieldGet(this, _TakeEnumerator_currentItem, "f") === undefined) {
            throw new Exception("Current is undefined");
        }
        return __classPrivateFieldGet(this, _TakeEnumerator_currentItem, "f");
    }
    moveNext() {
        var _a;
        __classPrivateFieldSet(this, _TakeEnumerator_currentItem, this.peek(), "f");
        if (__classPrivateFieldGet(this, _TakeEnumerator_currentItem, "f") === undefined) {
            return false;
        }
        __classPrivateFieldSet(this, _TakeEnumerator_itemsTaken, (_a = __classPrivateFieldGet(this, _TakeEnumerator_itemsTaken, "f"), _a++, _a), "f");
        return __classPrivateFieldGet(this, _TakeEnumerator_enumerator, "f").moveNext();
    }
    peek() {
        if (__classPrivateFieldGet(this, _TakeEnumerator_itemsTaken, "f") == __classPrivateFieldGet(this, _TakeEnumerator_itemsToTake, "f")) {
            return;
        }
        return __classPrivateFieldGet(this, _TakeEnumerator_enumerator, "f").peek();
    }
    reset() {
        __classPrivateFieldGet(this, _TakeEnumerator_enumerator, "f").reset();
    }
}
_TakeEnumerator_enumerator = new WeakMap(), _TakeEnumerator_itemsToTake = new WeakMap(), _TakeEnumerator_currentItem = new WeakMap(), _TakeEnumerator_itemsTaken = new WeakMap();
